// extracted by mini-css-extract-plugin
module.exports = {"container":"CardCheckbox-module__container--1yl5l"};